<script setup>
import MfEmpty from "@/components/core/MfEmpty.vue";
import fallbackImage from "@/assets/images/open_default.jpg";
import CalendarIcon from "@/components/icon/CalendarIcon.vue";
import { computed } from "vue";
defineProps(["item"]);

const baseUrl = computed(
  () => process.env.VUE_APP_BASE_API_URL + "/api/v2/info/file/"
);

const formattedValue = (createdAt) => {
  const dateObj = new Date(createdAt);
  const hours = dateObj.getUTCHours();
  const minutes = dateObj.getUTCMinutes();
  const day = dateObj.getUTCDate();
  const month = dateObj.getUTCMonth() + 1; // Adding 1 because months are zero-based
  const year = dateObj.getUTCFullYear();

  const formattedDate = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")} / ${day.toString().padStart(2, "0")}.${month
    .toString()
    .padStart(2, "0")}.${year}`;
  return formattedDate;
};

const formattedType = (type) => {
  return type.replaceAll("_", "-").toLowerCase();
};
</script>

<template>
  <div class="initiative-list" v-loading="item.loading">
    <template v-if="!item.loading">
      <div
        class="initiative-item"
        v-for="initiative in item.list"
        :key="initiative"
      >
        <a
          class="financial-tag"
          target="_blank"
          :href="`https://openbudget.uz/boards/initiatives/${formattedType(
            initiative.board_type
          )}/${initiative.board_id}/${initiative.id}`"
        >
          <img
            :src="
              initiative.images[0]
                ? baseUrl + initiative.images[0]
                : fallbackImage
            "
            class="image"
          />
          <div class="initiative-item-text">
            <div class="header">
              <p>{{ initiative.district_title }}</p>
              <p>ID: {{ initiative.public_id }}</p>
            </div>
            <div class="footer">
              <div class="statistics">
                <div class="date">
                  <CalendarIcon />
                  <span class="text">{{
                    formattedValue(initiative.created_at)
                  }}</span>
                </div>
                <div class="view-count">
                  <LikeIcon />
                  <span class="text">{{ initiative.vote_count }}</span>
                </div>
              </div>
              <p class="title">{{ initiative.category_title }}</p>
            </div>
          </div>
        </a>
      </div>
      <MfEmpty v-if="!item.list.length" />
    </template>
  </div>
</template>

<style scoped lang="scss">
.initiative {
  &-list {
    padding-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: space-between;
    flex-wrap: wrap;
    max-height: 500px;
    overflow-y: scroll;
    flex-direction: row;
  }

  &-item {
    height: 320px;
    position: relative;
    flex-basis: 48%;

    .image {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }

    &-text {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 20px;
      color: #ffffff;
      background: linear-gradient(
        360deg,
        rgba(0, 0, 0, 0.4) 10%,
        rgba(0, 0, 0, 0.4) 40%,
        rgba(0, 0, 0, 0.1) 100%
      );

      .header {
        color: #d2dfef;
      }

      .footer {
        .title {
          font-size: 20px;
          line-height: 22px;
        }

        .statistics {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;

          .date,
          .view-count {
            display: flex;
            align-items: center;
          }

          .text {
            margin-left: 5px;
            font-size: 16px;
          }
        }

        .like-count {
          display: flex;
          align-items: center;
          margin-top: 15px;

          .text {
            margin-left: 5px;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>
